// extracted by mini-css-extract-plugin
module.exports = {"outlet":"OutletSideDrawer_outlet__7QYg2","heading":"OutletSideDrawer_heading__QW48o"};